<template lang="pug">
v-form(autocomplete='false' v-model='formulario_validado')
  v-layout 
    v-flex.xs12.md6.pa-2
      v-autocomplete(:rules='[Rules.required]' v-model="Datos.proveedor_denominacion"  label='Buscar proveedor' item-value='name' :items="supplierRecord" :item-text='item => item.document +" - "+ item.name' )              
      
      v-menu(v-model='datePicker_fecha_de_emisión' :close-on-content-click='true' :nudge-right='40' transition='scale-transition' offset-y min-width='290px')
        template(v-slot:activator='{ on }')
          v-text-field(:rules='[Rules.required]' v-model='Datos.fecha_de_emision' label='Fecha de emisión' readonly v-on='on')
        v-date-picker(v-model='Datos.fecha_de_emision' @input='datePicker_fecha_de_emisión = false')
    
    v-flex.xs12.md6.pa-2
      v-autocomplete(:rules='[Rules.required]' v-model="Datos.tipo_de_comprobante"  label='Comprobante de pago' item-text='nombre_de_comprobante' :items="lista_de_documentos" item-value='value' )               
      span( :v-html='Datos.nombre_de_comprobante = Datos.tipo_de_comprobante ? lista_de_documentos.filter(item => item.value == Datos.tipo_de_comprobante )[0].nombre_de_comprobante : ""') 
      v-layout
        v-text-field(:rules='[Rules.required]'  v-model='Datos.serie_comprobante' label='Serie' @change='Datos.serie_comprobante = Datos.serie_comprobante.padStart(4, 0)' )
        v-text-field(:rules='[Rules.required]' v-model='Datos.numero_comprobante' label='- Nº' @change='Datos.numero_comprobante = Datos.numero_comprobante.padStart(9, 0)' )
</template>
<script>
import {mapState, mapGetters} from 'vuex'
import {obtener_llave} from '@/Helper'
export default {
  data: ()=>({
    lista_de_documentos: [
      { nombre_de_comprobante: 'Factura', value: 1 },
      { nombre_de_comprobante: 'Boleta', value: 2 },
      { nombre_de_comprobante: 'Nota de crédito', value: 3 },
      { nombre_de_comprobante: 'Nota de débito', value: 4 },
      { nombre_de_comprobante: 'Guía de remisión', value: 7},
    ],
    formulario_validado: false, 
    datePicker_fecha_de_emisión: false,
    datePicker_fecha_de_traslado: false,
  }),
  props: {
    modelo: String,
  },
  computed:{
    Modelo() { return this.$store.state[this.modelo] },
    Datos() { return this.$store.state[this.modelo].data },
    Rules() { return this.$store.state.Helpers.rules},
    ...mapGetters({
      supplierRecord: 'Suppliers/record',
      documentRecord: 'Documents/inputDocumentsRecord',
    }),
  },
  watch: {
    'Datos.proveedor_denominacion'(){
      this.Datos.proveedor_numero_de_documento = obtener_llave(this.supplierRecord, 'name', this.Datos.proveedor_denominacion, 'document')
    },
    'Datos.tipo_de_comprobante'(){
      this.Datos.nombre_de_comprobante = obtener_llave(this.documentRecord, 'code', this.Datos.tipo_de_comprobante, 'name')
    }
  }
}
</script>